import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = {
  class: "eryuan-btn__icon"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = {
  class: "intro-panel__inner"
};
const _hoisted_4 = {
  class: "intro-cover"
};
const _hoisted_5 = {
  key: 0,
  class: "swiper-container intro-swiper",
  ref: "swipercontainer"
};
const _hoisted_6 = {
  class: "swiper-wrapper"
};
const _hoisted_7 = ["src"];
const _hoisted_8 = {
  key: 1,
  class: "intro-cover__empty"
};
const _hoisted_9 = {
  key: 2,
  class: "intro-cover__bar"
};
const _hoisted_10 = {
  class: "intro-cover__dots"
};
const _hoisted_11 = {
  class: "intro-cover__count"
};
const _hoisted_12 = {
  class: "intro-body"
};
const _hoisted_13 = {
  class: "intro-meta"
};
const _hoisted_14 = {
  class: "intro-title"
};
const _hoisted_15 = {
  key: 0,
  class: "intro-audio"
};
const _hoisted_16 = {
  key: 0,
  class: "icon-play"
};
const _hoisted_17 = {
  key: 1,
  class: "icon-pause"
};
const _hoisted_18 = {
  class: "intro-audio__progress"
};
const _hoisted_19 = ["max", "value"];
const _hoisted_20 = {
  class: "intro-audio__time"
};
const _hoisted_21 = {
  class: "intro-desc"
};
const _hoisted_22 = ["innerHTML"];
const _hoisted_23 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["eryuan-intro", {
      'is-mobile': $props.isMobile
    }])
  }, [_withDirectives(_createElementVNode("div", {
    class: "eryuan-btn",
    onClick: _cache[0] || (_cache[0] = $event => $options.openIntro(true))
  }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("img", {
    src: $data.listIcon,
    alt: ""
  }, null, 8, _hoisted_2)]), _cache[13] || (_cache[13] = _createElementVNode("p", {
    class: "eryuan-btn__text"
  }, "洱源", -1))], 512), [[_vShow, !$data.introVisible]]), _withDirectives(_createElementVNode("div", {
    class: "eryuan-mask",
    onClick: _cache[5] || (_cache[5] = _withModifiers((...args) => $options.closeIntro && $options.closeIntro(...args), ["self"]))
  }, [_createElementVNode("div", {
    class: "intro-panel",
    onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"]))
  }, [_createElementVNode("button", {
    type: "button",
    class: "intro-close",
    "aria-label": "关闭",
    onClick: _cache[1] || (_cache[1] = (...args) => $options.closeIntro && $options.closeIntro(...args))
  }, [...(_cache[14] || (_cache[14] = [_createElementVNode("span", {
    class: "intro-close__x"
  }, null, -1)]))]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [$data.bannerList.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.bannerList, (item, i) => {
    return _openBlock(), _createElementBlock("div", {
      class: "swiper-slide",
      key: i
    }, [_createElementVNode("img", {
      src: $options.sethandleHttp(item.fileUrl),
      alt: ""
    }, null, 8, _hoisted_7)]);
  }), 128))])], 512)) : (_openBlock(), _createElementBlock("div", _hoisted_8)), $data.bannerList.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.bannerList, (item, i) => {
    return _openBlock(), _createElementBlock("span", {
      key: 'dot-' + i,
      class: _normalizeClass(["dot", {
        active: $data.currentSlide === i
      }])
    }, null, 2);
  }), 128))]), _createElementVNode("div", _hoisted_11, _toDisplayString($data.currentSlide + 1) + "/" + _toDisplayString($data.bannerList.length), 1)])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createElementVNode("h2", _hoisted_14, _toDisplayString($data.placeName || '洱源市简介'), 1), $data.audioUrl ? (_openBlock(), _createElementBlock("div", _hoisted_15, [_cache[15] || (_cache[15] = _createElementVNode("span", {
    class: "intro-audio__label"
  }, "讲解", -1)), _createElementVNode("button", {
    type: "button",
    class: _normalizeClass(["intro-audio__play", {
      playing: $data.isPlaying
    }]),
    onClick: _cache[2] || (_cache[2] = (...args) => $options.toggleAudio && $options.toggleAudio(...args))
  }, [!$data.isPlaying ? (_openBlock(), _createElementBlock("span", _hoisted_16)) : (_openBlock(), _createElementBlock("span", _hoisted_17))], 2), _createElementVNode("div", _hoisted_18, [_createElementVNode("input", {
    type: "range",
    class: "intro-audio__range",
    min: "0",
    max: $data.duration || 0,
    step: "0.1",
    value: $data.currentTime,
    style: _normalizeStyle($options.rangeStyle),
    onInput: _cache[3] || (_cache[3] = (...args) => $options.onSeek && $options.onSeek(...args))
  }, null, 44, _hoisted_19)]), _createElementVNode("span", _hoisted_20, [_createElementVNode("i", null, _toDisplayString($options.formatTime($data.currentTime)), 1), _createTextVNode("/" + _toDisplayString($options.formatTime($data.duration)), 1)])])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_21, [_createElementVNode("div", {
    class: "intro-desc__scroll",
    innerHTML: $options.formatIntroduce($data.introduce)
  }, null, 8, _hoisted_22)])])])])], 512), [[_vShow, $data.introVisible]]), _createElementVNode("audio", {
    ref: "audioEl",
    src: $data.audioUrl,
    preload: "auto",
    autoplay: "",
    playsinline: "",
    "webkit-playsinline": "",
    style: {
      "width": "0",
      "height": "0",
      "position": "absolute",
      "opacity": "0"
    },
    onTimeupdate: _cache[6] || (_cache[6] = (...args) => $options.onTimeUpdate && $options.onTimeUpdate(...args)),
    onLoadedmetadata: _cache[7] || (_cache[7] = (...args) => $options.onLoadedMeta && $options.onLoadedMeta(...args)),
    onCanplay: _cache[8] || (_cache[8] = (...args) => $options.onAudioCanPlay && $options.onAudioCanPlay(...args)),
    onLoadeddata: _cache[9] || (_cache[9] = (...args) => $options.onAudioCanPlay && $options.onAudioCanPlay(...args)),
    onEnded: _cache[10] || (_cache[10] = (...args) => $options.onAudioEnded && $options.onAudioEnded(...args)),
    onPlay: _cache[11] || (_cache[11] = $event => $data.isPlaying = true),
    onPause: _cache[12] || (_cache[12] = $event => $data.isPlaying = false)
  }, null, 40, _hoisted_23)], 2);
}